import BaseStore from 'core/stores/BaseStore';
import { action } from 'mobx';
import { ChannelService } from 'common/data';

class ChannelStore extends BaseStore {
	constructor(rootStore) {
		super(new ChannelService(rootStore.app.baasic.apiClient));
	}

	@action
	findChannel = async filter => {
		const response = await this.service.find(filter);
		if (filter && filter.search) {
			response.data.searchQuery = filter.search;
		}
		this.response = response.data;
	};

	@action
	getChannel = async (id, options) => {
		const channel = await this.service.get(id, options);
		this.item = channel.data;
		return channel.data;
	};

	@action
	updateChannel = async (channel, sourceOfChange) => {
		await this.service.update(channel, sourceOfChange);
	};

	@action
	createChannel = async (channel, sourceOfChange) => {
		// The API answers 201 with the created channel, so the caller can pick up the new id.
		const response = await this.service.create(channel, sourceOfChange);
		return response.data;
	};

	@action
	deleteChannel = async channel => {
		await this.service.delete(channel);
	};

	@action
	authorizeAmazon = async oAuthDate => {
		await this.service.authorizeAmazon(oAuthDate);
	};

	@action
	authorizeWalmart = async resource => {
		const response = await this.service.authorizeWalmart(resource);
		return response.data;
	};

	@action
	disconnectWalmart = async resource => {
		await this.service.disconnectWalmart(resource);
	};

	@action
	authorizeShopify = async uniqueIdentifier => {
		await this.service.authorizeShopify(uniqueIdentifier);
	};

	@action
	getAuthorizationResultAmazon = async state => {
		const oAuthResult = await this.service.authorizationResultAmazon(state);
		return oAuthResult.data;
	};

	@action
	updateChannelWarehouseCodes = async (updateChannelWarehouseCodesParams, sourceOfChange) => {
		const response = await this.service.updateChannelWarehouseCodes(updateChannelWarehouseCodesParams, sourceOfChange);
		return response.data;
	};

	@action
	updateChannelAmazonTemplates = async (updateChannelAmazonTemplatesParams, sourceOfChange) => {
		const response = await this.service.updateChannelAmazonTemplates(
			updateChannelAmazonTemplatesParams,
			sourceOfChange
		);
		return response.data;
	};

	@action
	updateChannelCustomLabel = async (updateChannelCustomLabelParams, sourceOfChange) => {
		const response = await this.service.updateChannelCustomLabel(updateChannelCustomLabelParams, sourceOfChange);
		return response.data;
	};

	@action
	getGoFlowStores = async ({ apiKey, subdomain }) => {
		const response = await this.service.getGoFlowStores({ apiKey, subdomain });
		this.response = response.data;
		return response.data;
	};

	@action
	getSellerCloudCompanies = async (filter) => {
		const response = await this.service.getSellerCloudCompanies(filter);
		this.response = response.data;
		return response.data;
	};

	@action
	getSellerCloudSavedViews = async (filter) => {
		const response = await this.service.getSellerCloudSavedViews(filter);
		this.response = response.data;
		return response.data;
	};

	@action
	getSellerCloudUrl = async teamName => {
		const response = await this.service.getSellerCloudUrl(teamName);
		this.response = response.data;
		return response.data;
	};

	@action
	getAmazonTemplates = async (filter) => {
		const response = await this.service.getAmazonTemplates(filter);
		this.response = response.data;
		return response.data;
	};

	@action
	getShipStationWarehouses = async ({ apiKey, apiSecret, apiKeyV2 }) => {
		const response = await this.service.getShipStationWarehouses({ apiKey, apiSecret, apiKeyV2 });
		this.response = response.data;
		return response.data;
	};
}

export default ChannelStore;
